import React, {FC} from "react";
import {CustomerComplexReportSearchParamsModel, PageEnum} from "../../../models";
import {ReportCustomersComplexSearchPanel, ReportPage,} from "../../../components";
import {searchAllSalesAndReturnTransactionsReport} from "../../../serviceBroker/transationReportApiServiceBroker";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {SearchReportAllCustomersTransaction} from "../../../serviceBroker/customersReportApiServiceBroker";

export const ReportAllCustomersTransactions: FC = () => {
    const initialState: CustomerComplexReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
        userId: getUserId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={SearchReportAllCustomersTransaction}
            searchHeader={getPageNameByPageId(PageEnum.ReportFollowCustomersInTransaction)}
            SearchPanel={ReportCustomersComplexSearchPanel}
            formId={PageEnum.ReportFollowCustomersInTransaction}
        />
    );
};
